import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";
import PromoBanner from "./PromoBanner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "#0B1220" }}>
      <PromoBanner />
      <AnnouncementBar cutoff="14:00" />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
